var _path, _ellipse, _ellipse2, _path2, _ellipse3, _path3, _ellipse4, _path4, _path5, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _path6, _ellipse12, _ellipse13, _ellipse14, _path7, _ellipse15, _ellipse16, _ellipse17, _path8, _path9, _ellipse18, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorgy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2436,
    height: 3172,
    viewBox: "0 0 2436 3172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M377 1099L364 1034L359 932L364 875L371 818L387 732L405 657L438 574L473 508L509 447L555 383L634 298L730 216L852 139L998 84L1176 51L1272 45L1344 51L1419 62L1511 84L1601 117L1697 170L1780 225L1875 311L1921 364L1963 416L2027 523L2061 599L2027 542L1942 427L1848 329L1716 230L1556 150L1445 112L1344 98L1251 92L1147 98L1051 112L982 131H998H1025L1061 143L1088 160L1107 182L1122 236L1117 282L1099 329L1061 373L982 416L915 459L848 517L730 657L689 705L653 721H616L579 710L549 695L522 657L509 625V567L522 517L541 459L509 508L453 619L421 715L398 790L387 863L382 969L398 1099L418 1179L453 1291L412 1211L377 1099Z",
    fill: "#2D4454"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 609.258,
    cy: 2559.43,
    rx: 303.445,
    ry: 124.314,
    transform: "rotate(-79.1403 609.258 2559.43)",
    fill: "#597182"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1418.5,
    cy: 257,
    rx: 109.5,
    ry: 78,
    fill: "#2D4454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M681.757 1086.67L724.241 1140.39L710.116 1208.58L681.27 1294.13L649.177 1355.84L617.796 1384.77L587.483 1406.14C586.553 1406.79 586 1407.86 586 1409V1431C586 1431.7 586.211 1432.39 586.607 1432.97L602.607 1456.47C602.896 1456.89 603.276 1457.25 603.718 1457.51L645.755 1482.37L617.872 1503.72C617.37 1504.11 616.981 1504.62 616.747 1505.21L602.247 1541.71C601.773 1542.9 601.991 1544.26 602.815 1545.24L630.815 1578.74C631.108 1579.1 631.468 1579.39 631.874 1579.6L692.419 1611.36L762.052 1679.5C762.287 1679.73 762.553 1679.93 762.843 1680.08L909.843 1759.08C909.976 1759.15 910.114 1759.22 910.255 1759.27L1058.76 1815.77C1059.15 1815.92 1059.57 1816 1060 1816H1398C1398.28 1816 1398.56 1815.97 1398.83 1815.9L1559.33 1776.9C1559.68 1776.82 1560.01 1776.68 1560.32 1776.49L1718.82 1679.99C1719.01 1679.87 1719.19 1679.74 1719.35 1679.59L1830.06 1579.36L1889.22 1546.05C1889.52 1545.88 1889.79 1545.67 1890.03 1545.42L1925.03 1508.92C1925.65 1508.27 1926 1507.4 1926 1506.5V1473C1926 1471.92 1925.5 1470.9 1924.65 1470.24L1875.48 1432L1932.79 1409.25C1933.9 1408.81 1934.71 1407.84 1934.94 1406.67L1941.94 1370.67C1942.18 1369.39 1941.71 1368.09 1940.69 1367.27L1890.03 1326.54L1848.47 1271.62L1806.26 1190.69L1777.87 1093.75L1810.25 1052.67C1810.36 1052.53 1810.46 1052.38 1810.54 1052.23L1848.54 985.227C1848.67 984.997 1848.78 984.754 1848.85 984.502L1871.85 907.502C1871.89 907.383 1871.92 907.263 1871.94 907.141L1890.94 805.141C1890.98 804.93 1891 804.715 1891 804.5V695.5C1891 695.404 1891 695.307 1890.99 695.211L1883.99 610.711C1883.97 610.533 1883.95 610.357 1883.9 610.184L1860.4 512.184C1860.32 511.829 1860.18 511.489 1859.99 511.177L1805.99 422.677C1805.59 422.028 1805 421.526 1804.29 421.246L1756.29 402.246C1755.5 401.935 1754.63 401.918 1753.84 402.198L1699.84 421.198C1699.61 421.277 1699.4 421.379 1699.2 421.501L1571.2 498.501C1570.94 498.656 1570.7 498.844 1570.49 499.06L1463.99 608.56C1463.89 608.668 1463.79 608.782 1463.7 608.902L1395.2 700.402C1395.14 700.475 1395.09 700.549 1395.04 700.626L1357.22 760.274L1280.4 751.522C1280.35 751.518 1280.31 751.514 1280.27 751.511C1280.18 751.504 1280.09 751.5 1280 751.5H1168C1167.85 751.5 1167.7 751.51 1167.54 751.53L1100.99 760.274L1083.27 738.359L1033.82 671.42C1033.74 671.314 1033.65 671.212 1033.56 671.115L959.061 591.115C958.963 591.01 958.859 590.91 958.749 590.818L862.749 510.318C861.568 509.328 859.879 509.227 858.588 510.068L847.088 517.568C846.813 517.748 846.565 517.965 846.35 518.213L783.35 591.213C783.295 591.278 783.241 591.344 783.19 591.413L744.297 643.77L686.517 706.982L633.25 725.383L596.314 718.093L580.448 713.631C579.345 713.321 578.16 713.57 577.276 714.297C576.392 715.025 575.919 716.14 576.011 717.281L586.011 841.281C586.022 841.413 586.04 841.544 586.066 841.674L602.066 923.174C602.074 923.219 602.084 923.265 602.095 923.309L616.595 984.309C616.664 984.601 616.771 984.883 616.912 985.147L648.912 1045.15C649.011 1045.33 649.126 1045.51 649.257 1045.67L681.755 1086.67L681.757 1086.67Z",
    fill: "#597182",
    stroke: "black",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1008.26,
    cy: 1279.96,
    rx: 76,
    ry: 108,
    transform: "rotate(5.64847 1008.26 1279.96)",
    fill: "#2D4454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1578 1200H1601V1208L1586 1213L1555.5 1224L1532.5 1235.5L1516 1247.5L1505 1264.5H1528.5L1555.5 1271.5L1578 1282.5L1586 1296H1572.5L1555.5 1289H1538.5H1516H1505L1482 1296H1475.5L1466.5 1301H1455.5L1449.5 1296V1289V1282.5L1455.5 1271.5L1466.5 1257.5L1482 1242.5L1498 1231L1516 1218L1538.5 1208L1555.5 1200H1578Z",
    fill: "#2D4454"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1030.5,
    cy: 1268,
    rx: 25.5,
    ry: 40,
    transform: "rotate(5.8294 1030.5 1268)",
    fill: "#597182"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.5 1080C1139.5 1005.2 1210.17 971.833 1246.5 964.5C1278.9 964.5 1299.67 975.5 1306 981C1319.17 988 1346.5 1012.7 1350.5 1055.5C1355.5 1109 1342.5 1140.5 1370.5 1262.5C1398.5 1384.5 1413 1392 1442.5 1425C1466.1 1451.4 1559.33 1445.67 1603 1439.5C1649.83 1426.67 1748.5 1397.2 1768.5 1382C1788.5 1366.8 1826.17 1375.67 1842.5 1382V1401L1870.5 1419L1908 1445.5L1842.5 1495L1761.5 1560.5L1653.5 1652.5L1517 1729C1499.83 1734.83 1449 1749.3 1383 1760.5C1300.5 1774.5 1276 1768.5 1243.5 1773.5C1217.5 1777.5 1143.67 1766.5 1110 1760.5L977 1716L855.5 1652.5C837 1636.33 795.4 1601.4 777 1591C754 1578 747.5 1577.5 688 1534.5C628.5 1491.5 650.5 1504 629.5 1488C608.5 1472 651.5 1494 676 1459.5C700.5 1425 684 1447.5 688 1425C691.2 1407 748.667 1417.5 777 1425C820 1442.17 920.2 1474.9 977 1468.5C1048 1460.5 1081 1437.5 1110 1412C1133.2 1391.6 1144.67 1321.5 1147.5 1289C1150.83 1250.5 1155.5 1154.8 1147.5 1080Z",
    fill: "#2D4454"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M814.098 1617.12C787.581 1604.79 687.034 1543.69 640.075 1514.68L609 1539.04L624.538 1558.94L769.039 1648.46L942.544 1758.86L1124.85 1818.05C1169.74 1821.03 1274.53 1825.21 1334.61 1818.05C1394.69 1810.88 1481.19 1792.52 1516.92 1784.23L1655.21 1702.67C1669.02 1697.03 1715.7 1668.85 1791.94 1601.21C1887.24 1516.66 1953.02 1514.68 1936.44 1490.8C1923.18 1471.71 1909.85 1469.92 1904.85 1471.41L1831.82 1528.1L1731.34 1591.26L1633.97 1641.49L1530.39 1685.76L1417.48 1713.61L1292.14 1733H1250.19L1130.03 1721.56C1098.96 1714.6 1016.92 1694.81 937.364 1671.33C837.923 1641.99 847.245 1632.54 814.098 1617.12Z",
    fill: "#597182"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 942,
    cy: 2438.5,
    rx: 615,
    ry: 455.5,
    fill: "#597182"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.422,
    cy: 1653.54,
    rx: 148.5,
    ry: 240.374,
    transform: "rotate(-18.9214 346.422 1653.54)",
    fill: "#597182"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.529,
    cy: 1804.85,
    rx: 262.552,
    ry: 151.967,
    transform: "rotate(25.8195 486.529 1804.85)",
    fill: "#597182"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 649.298,
    cy: 1903.07,
    rx: 449.5,
    ry: 157.5,
    transform: "rotate(24.5582 649.298 1903.07)",
    fill: "#597182"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.413,
    cy: 2589.1,
    rx: 148.738,
    ry: 226.636,
    transform: "rotate(-46.0248 266.413 2589.1)",
    fill: "#597182"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 312.315,
    cy: 2677.84,
    rx: 303.445,
    ry: 124.314,
    transform: "rotate(40.5902 312.315 2677.84)",
    fill: "#2D4454"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1318.5,
    cy: 2396,
    rx: 472.5,
    ry: 543,
    fill: "#597182"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2179.5 926.5C2179.5 1428.77 1764.11 1836.5 1251 1836.5C737.895 1836.5 322.5 1428.77 322.5 926.5C322.5 424.227 737.895 16.5 1251 16.5C1764.11 16.5 2179.5 424.227 2179.5 926.5Z",
    stroke: "black",
    strokeWidth: 33
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1835.54,
    cy: 1983.23,
    rx: 561.94,
    ry: 216.5,
    transform: "rotate(-26.464 1835.54 1983.23)",
    fill: "#597182"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2203.75,
    cy: 1725.91,
    rx: 169,
    ry: 186,
    transform: "rotate(17.336 2203.75 1725.91)",
    fill: "#597182"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 980,
    cy: 2157.5,
    rx: 415,
    ry: 331.5,
    fill: "#597182"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M448 1516L504.5 1604L560 1668.5L628.5 1715L705 1777L693 1738V1697L705 1676.5L803 1738C830 1751.83 902.4 1786.5 976 1814.5C1049.6 1842.5 1152.33 1851.83 1194.5 1853L1408.5 1844L1659.5 1763L1817 1668.5L1828.5 1738L1954 1698L2096 1593.5V1698L1841.5 1899.5L1325 2014.5L910 1969.5L407.5 1628.5V1479L376.5 1587L396 1468.5L407.5 1479L448 1516Z",
    fill: "#597182"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1254.64,
    cy: 1423.74,
    rx: 44.0741,
    ry: 74.3034,
    transform: "rotate(89.6136 1254.64 1423.74)",
    fill: "#0F212E"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1295.5,
    cy: 1415.04,
    rx: 42.439,
    ry: 56.9757,
    transform: "rotate(60.4162 1295.5 1415.04)",
    fill: "#0F212E"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1213.91,
    cy: 1417.22,
    rx: 36.7235,
    ry: 51.8329,
    transform: "rotate(-41.7451 1213.91 1417.22)",
    fill: "#0F212E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1218 1376C1212 1374.4 1208.83 1373.33 1208 1373L1216.5 1384.5L1249 1390L1300 1379.5L1287.5 1373L1236 1376C1232.5 1376.67 1224 1377.6 1218 1376Z",
    fill: "#0F212E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1254.5 1481L1253.5 1469L1222 1464L1220 1456L1282.5 1451L1312.5 1454.5L1281.5 1467V1491L1287.5 1502C1288.67 1504.5 1293.3 1511.2 1302.5 1518C1311.7 1524.8 1326.33 1527.17 1332.5 1527.5H1353.5L1369 1521.5L1379 1512C1381.67 1507.5 1387.2 1498.2 1388 1497C1388.8 1495.8 1391.33 1485.83 1392.5 1481V1469L1397.5 1464C1398.17 1463 1401.3 1461.1 1408.5 1461.5C1415.7 1461.9 1418.17 1467.67 1418.5 1470.5V1481L1417.5 1489.5L1415.5 1500L1410.5 1512L1403.5 1525L1391 1539L1377.5 1547.5L1363 1553L1360 1579.5L1353.5 1597L1344.5 1616.5L1332 1636.5L1313 1653.5L1296.5 1662L1277 1667L1254 1665L1233 1657.5L1210.5 1639L1193 1616.5L1183 1593L1176.5 1573V1561C1175.83 1560.67 1173 1559.6 1167 1558C1160.2 1556.4 1147.5 1549.33 1142 1546C1138.17 1542.17 1129.9 1533.8 1127.5 1531C1125.1 1528.2 1120.17 1516.17 1118 1510.5C1116.5 1506.5 1113.2 1497 1112 1491C1110.8 1485 1112.5 1480.5 1113.5 1479C1115.33 1475.67 1120.7 1469.5 1127.5 1471.5C1134.3 1473.5 1137.33 1478.67 1138 1481L1141 1495C1142.33 1499.5 1146.5 1510.4 1152.5 1518C1158.5 1525.6 1167.33 1529.83 1171 1531L1193 1534.5L1213 1531L1233 1521.5L1247 1504.5L1254.5 1481Z",
    fill: "#0F212E"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1121.24,
    cy: 2769.52,
    rx: 193.961,
    ry: 357.369,
    transform: "rotate(-36.7519 1121.24 2769.52)",
    fill: "#2D4454"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M907 2498.67C930.667 2471.67 1005.4 2413.97 1115 2399.17C1224.6 2384.37 1272.67 2393.01 1283 2399.17",
    stroke: "#2D4454",
    strokeWidth: 12
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1858.5 2814C1846 2836.17 1811.2 2879.2 1772 2874C1734.07 2868.97 1669.05 2822.96 1638.45 2798.39L1717 2709.5L1772 2591C1783.5 2531.83 1805.8 2404 1803 2366C1800.2 2328 1791.17 2269.83 1787 2245.5L1905.5 2200L2045.5 2127V2185.5C2038 2255.5 2015.5 2425.1 1985.5 2543.5C1955.5 2661.9 1888.33 2773.17 1858.5 2814Z",
    fill: "#2D4454"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1635.5 2796C1636.44 2796.77 1637.43 2797.57 1638.45 2798.39M1638.45 2798.39C1669.05 2822.96 1734.07 2868.97 1772 2874C1811.2 2879.2 1846 2836.17 1858.5 2814C1888.33 2773.17 1955.5 2661.9 1985.5 2543.5C2015.5 2425.1 2038 2255.5 2045.5 2185.5V2127L1905.5 2200L1787 2245.5C1791.17 2269.83 1800.2 2328 1803 2366C1805.8 2404 1783.5 2531.83 1772 2591L1717 2709.5L1638.45 2798.39Z",
    stroke: "#0F212E",
    strokeWidth: 25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorgy);
export default __webpack_public_path__ + "static/media/corgy.fe8ad1c90f5df79724da3af1bd4ee842.svg";
export { ForwardRef as ReactComponent };